import "./App.css";
import { Helmet } from "react-helmet-async";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Industries from "./components/Industries/Industries";
import WhyChoose from "./components/WhyChoose/WhyChoose";
import Products from "./components/ProductShowcase/ProductShowcase";
import Manufacturing from "./components/Manufacturing/Manufacturing";
import CompanyOverview from "./components/Company/CompanyOverview";
import CTA from "./components/CTA/CTA";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <>
      <Navbar />

      <main>
        <Hero />

        <WhyChoose />

        <CompanyOverview />

        <Products />

        <Industries />

        <Manufacturing />

        <CTA />

        <Contact />

        <Footer />
      </main>
      <Helmet>
        <title>
          TIGI Industries India Pvt. Ltd. | Industrial Packaging Solutions
        </title>

        <meta
          name="description"
          content="Leading manufacturer of flexible packaging, HDPE Carboys, LDPE Films, FIBC Bags, Woven Bags and industrial packaging solutions."
        />

        <meta
          name="keywords"
          content="Flexible Packaging, HDPE Carboys, LDPE Film, FIBC Bags, Packaging Manufacturer India"
        />
      </Helmet>
    </>
  );
}

export default App;
